// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__7vgHs","title":"AfterFrontImage_title__1V5qa"};